import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  containerRef?: React.RefObject<HTMLElement | null>;
}

/**
 * Scrolls to top on route changes.
 * If containerRef is provided, scrolls that element. Otherwise scrolls window.
 */
export const ScrollToTop: React.FC<ScrollToTopProps> = ({ containerRef }) => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Only scroll if pathname actually changed (not just search params)
    if (prevPathname.current !== pathname) {
      if (containerRef?.current) {
        containerRef.current.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
      prevPathname.current = pathname;
    }
  }, [pathname, containerRef]);

  return null;
};

export default ScrollToTop;
